//////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2026
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import SearchBox from "../components/SearchBox";
import SystemError from "../components/SystemError";
import Loader from "../components/search/Loader";
import {
  fetchAllBids,
  setSearchTerm,
  setPaginationParams
} from "../slices/searchAllBidsSlice";
import TableHeader from "../components/search/TableHeader";
import TableBody from "../components/search/TableBody";
import Pagination from "../components/form-controls/Pagination";
import messages from "../helpers/messages";

let _timeout;

function Search() {
  const dispatch = useDispatch();

  const {
    bids,
    isFetching,
    isError,
    searchTerm,
    pageNumber,
    limit,
    totalCount
  } = useSelector(state => state.searchAllBids);
  const {
    user: { division }
  } = useSelector(state => state.user);

  useEffect(() => {
    dispatch(fetchAllBids());
    _timeout = null;
  }, [dispatch]);

  const reloadPage = () => {
    dispatch(fetchAllBids());
  };

  const handleSearchBoxChange = e => {
    const searchInput = e.target.value.trimLeft();
    dispatch(setSearchTerm(searchInput));
    if (searchInput.length >= 3 || e.target.value === "") {
      clearTimeout(_timeout);
      _timeout = setTimeout(function () {
        dispatch(fetchAllBids());
      }, 1000);
    }
  };

  const handleSearchBoxBlur = e => {
    if (e.target.value && e.target.value.length < 3) {
      dispatch(setSearchTerm(""));
      dispatch(fetchAllBids());
    }
  };

  const handlePagination = pageDetails => {
    const { offset } = pageDetails;
    let paginationParams;
    if (pageDetails.limit === limit) {
      paginationParams = {
        pageNumber: offset / pageDetails.limit + 1,
        limit: pageDetails.limit
      };
    } else {
      paginationParams = {
        pageNumber: 1,
        limit: pageDetails.limit
      };
    }
    dispatch(setPaginationParams(paginationParams));
    dispatch(fetchAllBids());
  };

  return (
    <>
      {isError ? (
        <SystemError reloadPage={reloadPage} />
      ) : (
        <div
          data-testid="search-all-bids one-whole"
          className="search-all-bids py-24 page-container"
        >
          <>
            <div className="one-whole px-24">
              <div className="grid__cell one-half">
                <h1 data-testid="search">
                  {messages.searchAllBids.defaultMessage}
                </h1>
              </div>
              <div className="grid__cell one-half text-right">
                <SearchBox
                  placeholder={messages.search.defaultMessage}
                  inputTitle={
                    messages.searchAllBidsSearchBoxPlaceHolderV2.defaultMessage
                  }
                  width="360px"
                  value={searchTerm}
                  onChange={handleSearchBoxChange}
                  onBlur={handleSearchBoxBlur}
                />
              </div>
            </div>
            <table className="one-whole search-grid mx-24">
              <TableHeader />
              {isFetching ? (
                <Loader />
              ) : (
                <>
                  {bids && bids.length > 0 && (
                    <TableBody bids={bids} division={division} />
                  )}
                </>
              )}
            </table>

            {!isFetching && (
              <div className="one-whole p-20 fr">
                <Pagination
                  onChange={handlePagination}
                  limit={limit}
                  offset={(pageNumber - 1) * limit}
                  total={totalCount}
                  perPageOptions={[10, 25, 50]}
                />
              </div>
            )}
          </>
        </div>
      )}
    </>
  );
}

export default Search;
